import type { LoaderFunctionArgs } from 'react-router';
import { useLoaderData } from 'react-router';
import { apolloClient } from '~/apollo/client-v3';
import { graphql } from '~/apollo/generated/v3';
import { UpdateDepositionalWikiForm } from '~/components/upload/depositional-wiki/update-depositional-wiki-form';
import { requireRouteParam } from '~/hooks/routing';

const UPLOAD_DEPOSITIONAL_WIKI_UPDATE_PAGE = graphql(`
  query UploadDepositionalWikiUpdatePage($id: Int) {
    depositionalList(id: $id) {
      ...depositionalWikiParts
    }
  }
`);

async function loader({ params }: LoaderFunctionArgs) {
  const wikiId = requireRouteParam(params, 'depositionalId', parseInt);
  const { data } = await apolloClient.query({
    query: UPLOAD_DEPOSITIONAL_WIKI_UPDATE_PAGE,
    variables: { id: wikiId },
  });
  const depositionalWiki = data?.depositionalList.find(
    wiki => wiki.id === wikiId,
  );
  if (!depositionalWiki) {
    throw new Error('Depositional wiki not found');
  }
  return { depositionalWiki };
}

export default function UploadDepositionalWikiUpdatePage() {
  const { depositionalWiki } = useLoaderData<typeof loader>();

  return <UpdateDepositionalWikiForm wikiPage={depositionalWiki} />;
}
UploadDepositionalWikiUpdatePage.loader = loader;
